import { Component, ChangeDetectionStrategy, computed, inject, OnInit } from '@angular/core';

import { HeroComponent } from '../../components/hero/hero.component';
import { TrustBarComponent } from '../../components/trust-bar/trust-bar.component';
import { ProblemComponent } from '../../components/problem/problem.component';
import { IdealStateComponent } from '../../components/ideal-state/ideal-state.component';
import { SolutionComponent } from '../../components/solution/solution.component';
import { FeaturesComponent } from '../../components/features/features.component';
import { ProblemSolutionResultComponent } from '../../components/problem-solution-result/problem-solution-result.component';
import { PortfolioComponent } from '../../components/portfolio/portfolio.component';
import { ServiceDirectionsComponent } from '../../components/service-directions/service-directions.component';
import { WebSupervisionComponent } from '../../components/web-supervision/web-supervision.component';
import { PricingComponent } from '../../components/pricing/pricing.component';
import { ProcessComponent } from '../../components/process/process.component';
import { QuoteRequestComponent } from '../../components/quote-request/quote-request.component';
import { WhyUsComponent } from '../../components/why-us/why-us.component';
import { FaqComponent } from '../../components/faq/faq.component';
import { ContactCtaComponent } from '../../components/contact-cta/contact-cta.component';
import { SiteConfigService } from '../../services/site-config.service';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-landing',
  imports: [
    HeroComponent,
    ProblemComponent,
    IdealStateComponent,
    SolutionComponent,
    FeaturesComponent,
    ProblemSolutionResultComponent,
    PortfolioComponent,
    ServiceDirectionsComponent,
    WebSupervisionComponent,
    PricingComponent,
    ProcessComponent,
    QuoteRequestComponent,
    WhyUsComponent,
    FaqComponent,
    ContactCtaComponent,
  ],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingComponent implements OnInit {
  private readonly siteConfig = inject(SiteConfigService);
  private readonly seo = inject(SeoService);

  readonly showTrustBar = computed(() => this.siteConfig.config().features.trustBar);
  readonly showProblem = computed(() => this.siteConfig.config().features.problem);
  readonly showIdealState = computed(() => this.siteConfig.config().features.idealState);
  readonly showSolution = computed(() => this.siteConfig.config().features.solution);
  readonly showFeatures = computed(() => this.siteConfig.config().features.features);
  readonly showPsr = computed(() => this.siteConfig.config().features.problemSolutionResult);
  readonly showPortfolio = computed(() => this.siteConfig.config().features.portfolio);
  readonly showServiceDirections = computed(() => this.siteConfig.config().features.serviceDirections);
  readonly showWebSupervision = computed(() => this.siteConfig.config().features.webSupervision);
  readonly showPricing = computed(() => this.siteConfig.config().features.pricing);
  readonly showProcess = computed(() => this.siteConfig.config().features.process);
  readonly showQuoteRequest = computed(() => this.siteConfig.config().features.quoteRequest);
  readonly showWhyUs = computed(() => this.siteConfig.config().features.whyUs);
  readonly showFaq = computed(() => this.siteConfig.config().features.faq);
  readonly showContactForm = computed(() => this.siteConfig.config().features.contactForm);

  ngOnInit(): void {
    const seo = this.siteConfig.profile()?.seo;
    if (seo) {
      this.seo.apply(seo);
    }
  }
}
